import { Handle, Position, NodeProps } from '@xyflow/react';
import { FlowNodeTypeValue } from '../types';
import { getNodeInfo } from '../metadata';

interface ActionNodeData {
  type: FlowNodeTypeValue;
  config: string;
  [key: string]: unknown;
}

const PREVIEW_KEYS = ['message', 'question', 'systemPrompt', 'url', 'value'] as const;

export function ActionNode({ data, selected }: NodeProps) {
  const d = data as ActionNodeData;
  const info = getNodeInfo(d.type);
  const preview = getPreview(d.config) || info.label;

  return (
    <div
      className="wt-rf-node"
      data-selected={selected ? 'true' : 'false'}
      style={{ borderColor: info.color }}
    >
      <Handle type="target" position={Position.Top} className="wt-rf-port" />
      <div className="wt-rf-node-head" style={{ color: info.color }}>
        <span className="wt-rf-node-dot" style={{ background: info.color }} />
        <span>{info.label}</span>
      </div>
      <div className="wt-rf-node-preview">{preview}</div>
      <Handle type="source" position={Position.Bottom} className="wt-rf-port" />
    </div>
  );
}

function getPreview(configJson: string): string {
  try {
    const cfg = JSON.parse(configJson || '{}');
    for (const key of PREVIEW_KEYS) {
      const v = cfg[key];
      if (typeof v === 'string' && v.length > 0) {
        return v.length > 40 ? v.slice(0, 40) + '...' : v;
      }
    }
  } catch {
    /* fallthrough */
  }
  return '';
}
